import React from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';

export const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY?.trim() ?? '';
export const googleMapsMapId = process.env.REACT_APP_GOOGLE_MAP_ID?.trim() || 'DEMO_MAP_ID';
export const hasGoogleMapsApiKey = Boolean(googleMapsApiKey);

export function GoogleMapsProvider({ children }: { children: React.ReactNode }) {
  if (!hasGoogleMapsApiKey) {
    return <>{children}</>;
  }

  return (
    <APIProvider apiKey={googleMapsApiKey}>
      {children}
    </APIProvider>
  );
}
